import { CircularProgress, Typography } from "@mui/material";
import {
  useGetConfigQuery,
  useUpdateConfigMutation,
} from "@/app/features/config/configApiSlice";
import ConfigForm from "@/pages/configuration/components/ConfigForm";
import useSnackbar from "@/hooks/use-snackbar";

function ConfigurationPage() {
  const [updateConfig, { isLoading: updateConfigLoading }] =
    useUpdateConfigMutation();
  const { data, error, isLoading, refetch } = useGetConfigQuery();

  const { showSnackbar, snackbar } = useSnackbar();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Typography align="center" sx={{ mb: 3 }} variant="h3">
        Something went wrong
      </Typography>
    );
  }

  const {
    id: configId,
    privacyPolicyDetail,
    termsConditionsDetail,
    aboutDetail,
    advertiseDetail,
    pricingWorksDetail,
    mediaDetail,
  } = data?.data?.data;

  const handleSubmit = async (configData) => {
    const {
      privacyPolicy: privacyPolicyDetail,
      termsConditions: termsConditionsDetail,
      about: aboutDetail,
      advertise: advertiseDetail,
      pricingWorks: pricingWorksDetail,
      media: mediaDetail,
    } = configData;

    const updatedConfigData = {
      id: configId,
      privacyPolicyDetail: encodeURI(privacyPolicyDetail),
      termsConditionsDetail: encodeURI(termsConditionsDetail),
      aboutDetail,
      advertiseDetail,
      pricingWorksDetail,
      mediaDetail,
    };

    const { error } = await updateConfig(updatedConfigData);
    if (error) {
      showSnackbar({
        message: "Some error occurred",
        type: "error",
      });
      return;
    }

    showSnackbar({ message: "Successfully Updated" });
    refetch();
  };

  return (
    <>
      {snackbar}
      <ConfigForm
        onSubmit={handleSubmit}
        isLoading={updateConfigLoading}
        initialValues={{
          privacyPolicy: decodeURI(privacyPolicyDetail),
          termsConditions: decodeURI(termsConditionsDetail),
          about: aboutDetail,
          advertise: advertiseDetail,
          pricingWorks: pricingWorksDetail,
          media: mediaDetail,
        }}
      />
    </>
  );
}

export default ConfigurationPage;
